import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const TestimonialTwo = () => {
  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div className="TestimonialTwo-icon-box-next">
        <button
          onClick={onClick}
          className="slick-arrow style2 default team-slider2-next"
        >
          <i className="fas fa-arrow-right" />
        </button>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div className="TestimonialTwo-icon-box-prev">
        <button
          onClick={onClick}
          className="team-slider2 slick-arrow style2 default team-slider2-prev"
        >
          <i className="fas fa-arrow-left" />
        </button>
      </div>
    );
  }

  let settings = {
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    cssEase: "linear",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {},
      },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="testimonial-area-2 space-bottom">
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="title-area">
              <span className="sub-title">
                <img src="assets/img/icon/title_left.svg" alt="Ícone Depoimentos Rocvel" />
                Depoimentos de Clientes
              </span>
              <h2 className="sec-title style2">
                Pronto para construir a sua próxima equipe de alta performance?
              </h2>
              <p className="sec-text">
                Não permita que a escassez de profissionais qualificados trave a expansão da sua empresa. Entre em contato com os especialistas em recrutamento estratégico do Grupo Rocvel e tenha acesso às melhores soluções do mercado.
              </p>
            </div>
            <div className="feature-wrapper">
              <div className="feature-icon">
                <Link to="/contato">
                  <img src="assets/img/icon/call.svg" alt="Contato Rocvel" />
                </Link>
              </div>
              <div className="media-body">
                <span className="header-info_label">Iniciar Parceria Corporativa</span>
                <p className="header-info_link">
                  <Link to="tel:+5511915259017">(11) 91525-9017</Link>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="testiomonial-wrap-2">
              <div className="row global-carousel slider-shadow testi-slider-2">
                <Slider {...settings}>
                  <div>
                    <div className="testi-box">
                      <div className="quote-icon">
                        <img src="assets/img/icon/quote2-1.svg" alt="Citação Rocvel" />
                      </div>
                      <div className="testi-box_content">
                        <p className="testi-box_text">
                          "Estávamos enfrentando sérios problemas com a retenção de talentos no nosso setor administrativo e operacional. Contratávamos rápido, mas os profissionais não se adaptavam à nossa cultura, o que gerava um turnover altíssimo e um prejuízo enorme com treinamentos e demissões. Quando iniciamos a parceria com o Grupo Rocvel, a chave virou. O processo de recrutamento consultivo e o mapeamento de perfil que eles realizam são cirúrgicos. Em menos de 6 meses de parceria, reduzimos nossa taxa de turnover em 42% e hoje temos uma equipe muito mais sinérgica, engajada e focada em resultados. É uma consultoria premium que se tornou indispensável para o nosso crescimento estruturado."
                        </p>
                        <div className="testi-box-profile">
                          <div className="testi-box-profile-details">
                            <h4 className="testi-profile-title">
                              Roberto Silveira
                              <span style={{ display: "block", fontSize: "14px", fontWeight: "400", marginTop: "4px", color: "#666" }}>
                                Diretor de Operações | Indústria de Alimentos
                              </span>
                            </h4>
                          </div>
                          <div className="testi-profile_thumb">
                            <img
                              src="assets/img/home/9.png"
                              alt="Roberto Silveira"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="testi-box">
                      <div className="quote-icon">
                        <img src="assets/img/icon/quote2-1.svg" alt="Citação Rocvel" />
                      </div>
                      <div className="testi-box_content">
                        <p className="testi-box_text">
                          "Ficar com posições de liderança e cadeiras executivas abertas por meses estava travando o nosso planejamento comercial. Nosso RH interno estava sobrecarregado com as demandas do dia a dia e não conseguia encontrar profissionais de mercado com o nível técnico que precisávamos. O Grupo Rocvel assumiu o Hunting dessas vagas de difícil acesso e superou todas as nossas expectativas. A agilidade deles na triagem e na entrega de candidatos extremamente qualificados reduziu drasticamente o nosso tempo de contratação. Eles não apenas preencheram as vagas, mas nos conectaram com líderes de alta performance que já estão gerando impacto direto no faturamento da empresa."
                        </p>
                        <div className="testi-box-profile">
                          <div className="testi-box-profile-details">
                            <h4 className="testi-profile-title">
                              Mariana Vasconcellos
                              <span style={{ display: "block", fontSize: "14px", fontWeight: "400", marginTop: "4px", color: "#666" }}>
                                CHRO / Diretora de RH | Rede de Franquias
                              </span>
                            </h4>
                          </div>
                          <div className="testi-profile_thumb">
                            <img
                              src="assets/img/home/9.png"
                              alt="Mariana Vasconcellos"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="testi-box">
                      <div className="quote-icon">
                        <img src="assets/img/icon/quote2-1.svg" alt="Citação Rocvel" />
                      </div>
                      <div className="testi-box_content">
                        <p className="testi-box_text">
                          "Durante a fase de expansão acelerada da nossa empresa, nossa maior dor era estruturar equipes inteiras de logística e atendimento no menor tempo possível. Foi aí que contratamos o modelo de RPO (Terceirização de Recrutamento) do Grupo Rocvel. Eles atuaram como um braço de elite acoplado à nossa operação, assumindo de ponta a ponta a triagem e o recrutamento em grande escala. O resultado foi surpreendente: conseguimos inaugurar três novas unidades dentro do prazo, com times completos, integrados e com total segurança operacional e jurídica. A flexibilidade da estrutura deles nos deu a escalabilidade que precisávamos para crescer."
                        </p>
                        <div className="testi-box-profile">
                          <div className="testi-box-profile-details">
                            <h4 className="testi-profile-title">
                              Guilherme Andrade
                              <span style={{ display: "block", fontSize: "14px", fontWeight: "400", marginTop: "4px", color: "#666" }}>
                                CEO & Co-fundador | Hub de Logística
                              </span>
                            </h4>
                          </div>
                          <div className="testi-profile_thumb">
                            <img
                              src="assets/img/home/9.png"
                              alt="Guilherme Andrade"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialTwo;